export default __webpack_public_path__ + "static/media/bento-color.b6e674ef.png";